const DefaultCreditCard = ({ creditCard, creditCardCount }) => {
  if (creditCard.isDefault && creditCardCount > 1) {
    return (
      <>
        <br />
        <em>(Default for Website)</em>
      </>
    );
  }
  return null;
};

export default DefaultCreditCard;
